<form [formGroup]='propertyTypeTo'
      (ngSubmit)='onSubmit()'
      id='{{formGroupName}}'>

	<div class='step-title' i18n>What is your new <span class='color-blue'>property type</span>?</div>

	<div class='form-control property-type-control'>
		<mat-radio-group (change)='onRadioChange($event)' formControlName='propertyType' aria-label='Select an option' class='custom-radio-group'>
			<mat-radio-button value='1' [tabIndex]='formService.verifyTabIndex( formGroupName )'>
				<div class='option'>
					<mat-icon inline="true" svgIcon='images:property-type-house' class='option-icon'></mat-icon>
					<div class='option-name' i18n='@@house'>House</div>
				</div>
			</mat-radio-button>
			<mat-radio-button value='2' [tabIndex]='formService.verifyTabIndex( formGroupName )'>
				<div class='option'>
					<mat-icon inline="true" svgIcon='images:property-type-apartment' class='option-icon'></mat-icon>
					<div class='option-name' i18n='@@apartment'>Apartment / flat</div>
				</div>
			</mat-radio-button>
		</mat-radio-group>
	</div>

	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backMainForm()'><mat-icon svgIcon='icons:chevron-left'></mat-icon><ng-container i18n='@@buttonBack'>Back</ng-container></button>
			<button class='submit' type='submit'><ng-container i18n='@@buttonContinue'>Continue</ng-container><mat-icon svgIcon='icons:chevron-right'></mat-icon></button>
		</div>
	</div>
</form>

